import MuiDialog, { DialogProps as MuiDialogProps } from '@mui/material/Dialog';
import MUIDialogActions, { DialogActionsProps } from '@mui/material/DialogActions';
import MUIDialogContent, { DialogContentProps } from '@mui/material/DialogContent';
import MUIDialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle';

export const Dialog = (props: MuiDialogProps) => {
	return <MuiDialog {...props} />;
};

export const DialogTitle = (props: DialogTitleProps) => {
	return <MUIDialogTitle {...props} />;
};

export const DialogContent = (props: DialogContentProps) => {
	return <MUIDialogContent {...props} />;
};

export const DialogActions = (props: DialogActionsProps) => {
	return <MUIDialogActions {...props} />;
};
